import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { formatPercentage } from "../../../utils/formatPercentage";
import SchemeSummaryCard from "../../shared/scheme_dashboard/SchemeSummaryCard";

type SummaryWidgetProps = {
  level1Resource: any;
};

const SummaryWidget: React.FunctionComponent<SummaryWidgetProps> = ({
  level1Resource,
}) => {
  const { t } = useTranslation();
  const [noOfCustomers, setNoOfCustomers] = useState(0);

  useEffect(() => {
    const subsciberWallets = new Set();

    if (level1Resource) {
      level1Resource.level0WRSMembers.forEach((zone: any) => {
        zone.extractionRights.forEach((entitlement: any) =>
          subsciberWallets.add(entitlement.assertedByWalletId)
        );
      });

      setNoOfCustomers(subsciberWallets.size);
    }
  }, [level1Resource]);

  return (
    <SchemeSummaryCard
      className="w-1/2 lg:w-1/5 shadow-none"
      title={t("level1wrs.widget_title")}
      labels={{
        volume: t("level1wrs.volume_available"),
        subscribers: t("level1wrs.subscribers_count"),
        used: t("level1wrs.volume_used"),
        remaining: t("level1wrs.volume_remain"),
      }}
      volume={level1Resource?.volume}
      subscriberCount={noOfCustomers}
      used={{
        volume: level1Resource?.usedVolume,
        percent: level1Resource
          ? formatPercentage(level1Resource.usedVolume / level1Resource.volume)
          : "",
      }}
      remaining={{
        volume: level1Resource?.remainingVolume,
        percent: level1Resource
          ? formatPercentage(
              level1Resource.remainingVolume / level1Resource.volume
            )
          : "",
      }}
    />
  );
};

export default SummaryWidget;
